import { connect } from 'react-redux'
import { trackAdoptionMetricsForCropBannerClickedEvent,
  trackAdoptionMetricsForBannerAddedEvent,trackAdoptionMetricsForAddBannerForCollectionClickedEvent,trackAdoptionMetricsForCropBannerClickedCollectionEvent,
  trackAdoptionMetricsForBannerAddedCollectionEvent,trackAdoptionMetricsForFilterBannerClickedEvent,trackAdoptionMetricsForBannerFilteredEvent
  
} from 'src/legacy/redux/actions/adoption.jsx';

import BannerImageEditor from './view'

const mapStateToProps = (state, ownProps) => {

  return {
    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    
   trackAdoptionMetricsForCropBannerClickedEvent : (bannerType,cta) =>{
    return dispatch(trackAdoptionMetricsForCropBannerClickedEvent(bannerType,cta));
   },
   trackAdoptionMetricsForBannerAddedEvent: (bannerType,cta) =>{
    return dispatch(trackAdoptionMetricsForBannerAddedEvent(bannerType,cta));
   },
   trackAdoptionMetricsForAddBannerForCollectionClickedEvent: (cta,folioName) =>{
    return dispatch(trackAdoptionMetricsForAddBannerForCollectionClickedEvent(cta,folioName));
   },
   trackAdoptionMetricsForCropBannerClickedCollectionEvent : (folioName,bannerType,cta) =>{
    return dispatch(trackAdoptionMetricsForCropBannerClickedCollectionEvent(folioName,bannerType,cta));
   },
   trackAdoptionMetricsForBannerAddedCollectionEvent: (collectionName,bannerType,cta) =>{
    return dispatch(trackAdoptionMetricsForBannerAddedCollectionEvent(collectionName,bannerType,cta));
   },
   trackAdoptionMetricsForFilterBannerClickedEvent : (collectioName,bannerType,cta) => {
    return dispatch(trackAdoptionMetricsForFilterBannerClickedEvent(collectioName,bannerType,cta));
   },
   trackAdoptionMetricsForBannerFilteredEvent : (collectioName,bannerType,cta) =>{
    return dispatch(trackAdoptionMetricsForBannerFilteredEvent(collectioName,bannerType,cta))
   }
  }
}

const BannerImageEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BannerImageEditor)

export default BannerImageEditorContainer;